/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSidebar } from "../context/SidebarContext";
// import { WhatshappIcon, OpenMenuIcon } from "../icons";
const WhatshappIcon = (_props: any) => null;
const OpenMenuIcon = (_props: any) => null;
import logo from "../assets/logo/logo.png";
import avatar from "../assets/images/user/avatar.png";
import footerLogo from "../assets/logo/logo_footer.png";
import { useNavigation } from "../context/NavigationContext";
import RegisterModal from "../pages/Auth/Register/home";
import LoginModal from "../pages/Auth/Login/home";
import httpService from "../services/httpService";
import { useAuth } from "../context/AuthContext";
import {
    LogInIcon, ChevronDown, Search, FileText, Shield, Award, Users, Phone, HelpCircle,
    Info, Radio, Newspaper, GraduationCap, BookOpen, Smartphone, Cpu, Key, FilePlus,
    Activity, ArrowRight, Wrench, ChevronRight, Tablet, Watch, Monitor, Battery,
    Droplets, Camera, Volume2, Mic, Power, CircuitBoard, Code, Zap, Fingerprint,
    Menu, X, Home, Store, Building2, Briefcase, Wrench as WrenchIcon, Tag, LayoutDashboard,
    ArrowUpLeft, Facebook, Twitter, Youtube, User, Package, Settings, ClipboardCheck, LogOut,
    CheckSquare,
    LogIn,
    UserPlus
} from "lucide-react";
import ForgotPasswordModal from "../pages/Auth/ForgotPassword/ForgotPassword";
import { smartphoneRepairs, featurePhoneRepairs, tabletRepairs, smartWatchRepairs } from "../pages/Dashboard/homeData";

// Helper component for User Menu (Standard styling for profile dropdown)
const MenuItem = ({
    label,
    onClick,
    danger = false,
}: {
    label: string;
    onClick: () => void;
    danger?: boolean;
}) => (
    <button
        onClick={onClick}
        className={`block w-full text-left px-4 py-2 text-sm transition-colors hover:bg-gray-100 ${danger ? "text-red-600 hover:bg-red-50" : "text-gray-700"
            }`}
    >
        {label}
    </button>
);

const getIcon = (name: string) => {
    const iconMap: Record<string, React.ElementType> = {
        // Company dropdown
        "Terms & Conditions": FileText,
        "Privacy Policy": Shield,
        "Warranty Policy": Award,
        "Warranty Claim": Activity,
        "Meet Our Team": Users,
        "Contact Us": Phone,
        "FAQs": HelpCircle,
        "About Us": Info,
        // Live dropdown
        "Live": Radio,
        "Latest News": Newspaper,
        // Training Center dropdown
        "Academy": GraduationCap,
        "Courses": BookOpen,
        // System dropdown
        "Phone Screen": Smartphone,
        "Part & IC Chip": Cpu,
        "Acess Zone": Key,
        "Counter Order": FilePlus,
        "Official DOS": FileText,
        // Booking Repair device categories
        "SmartPhone": Smartphone,
        "Feature Phone": Phone,
        "Tablet": Tablet,
        "Smart Watch": Watch,
    };

    // Smart icon matching for repair sub-menu items
    const lowerName = name.toLowerCase();
    if (lowerName.includes("display")) return <Monitor className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("touch screen") || lowerName.includes("touch repair")) return <Fingerprint className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("battery")) return <Battery className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("back glass") || lowerName.includes("body")) return <Smartphone className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("charging")) return <Zap className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("camera")) return <Camera className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("speaker")) return <Volume2 className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("mic")) return <Mic className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("power button")) return <Power className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("water damage")) return <Droplets className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("motherboard")) return <CircuitBoard className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
    if (lowerName.includes("software")) return <Code className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;

    const Icon = iconMap[name] || ArrowRight;
    return <Icon className="w-4 h-4 mr-2.5 opacity-70" strokeWidth={2} />;
};

// Mobile menu item icons mapping
const getMobileIcon = (item: string) => {
    const iconMap: Record<string, React.ElementType> = {
        "Home": Home,
        "Franchise": Store,
        "Company": Building2,
        "Jobs": Briefcase,
        "Booking Repair": WrenchIcon,
        "Offers Today": Tag,
        "Dashboard": LayoutDashboard,
    };
    const Icon = iconMap[item] || ArrowRight;
    return <Icon className="w-5 h-5" strokeWidth={2} />;
};

const AppHeader: React.FC = () => {
    // Context & State
    const { isExpanded, toggleSidebar, toggleMobileSidebar, isMobileOpen } = useSidebar();
    const { activeNav, setActiveNav } = useNavigation();
    const navigate = useNavigate();
    const location = useLocation();

    // Local State
    const [isApplicationMenuOpen, setApplicationMenuOpen] = useState(false);
    const [hoveredItem, setHoveredItem] = useState<string | null>(null);
    const [hoveredSubItem, setHoveredSubItem] = useState<string | null>(null);
    const [isRegisterOpen, setRegisterOpen] = useState(false);
    const [isLoginOpen, setLoginOpen] = useState(false);
    const [isForgotPasswordOpen, setForgotPasswordOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [isSearchOpen, setSearchOpen] = useState(false);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isMenuClosing, setIsMenuClosing] = useState(false);
    const [expandedMobileItem, setExpandedMobileItem] = useState<string | null>(null);
    const [expandedMobileSubItem, setExpandedMobileSubItem] = useState<string | null>(null);
    const [mobileSearchQuery, setMobileSearchQuery] = useState("");
    const [isMobileProfileMenuOpen, setIsMobileProfileMenuOpen] = useState(false);
    const { user, fetchUser, logout } = useAuth();
    const [isAuthDropdownOpen, setIsAuthDropdownOpen] = useState(false);
    const [hasScrolled, setHasScrolled] = useState(false);

    const closeMobileMenu = () => {
        setIsMenuClosing(true);
        setTimeout(() => {
            setMobileMenuOpen(false);
            setIsMenuClosing(false);
        }, 280); // Slightly less than animation duration for safety
    };

    const inputRef = useRef<HTMLInputElement>(null);
    const subMenuTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearSubMenuTimer = () => {
        if (subMenuTimer.current) {
            clearTimeout(subMenuTimer.current);
            subMenuTimer.current = null;
        }
    };

    const startSubMenuTimer = () => {
        clearSubMenuTimer();
        subMenuTimer.current = setTimeout(() => setHoveredSubItem(null), 500);
    };

    // --- Navigation Logic ---
    const menuRoutes: Record<string, string> = {
        Home: "/",
        Franchise: "/franchise",
        Jobs: "/jobs",
        "Training Center": "/training-center",
        Company: "/company",
        System: "/system",
        "Booking Repair": "/booking-repair",
        "Offers Today": "/offers",
        "Dashboard": "/applicant/dashboard",
        Live: "/live",
    };

    const dropdownRoutes: Record<string, string> = {
        Academy: "/training-center/academy",
        Courses: "/training-center/courses",
        "Terms & Conditions": "/company/terms",
        "Privacy Policy": "/company/privacy-policy",
        "Warranty Policy": "/company/warranty-policy",
        "Warranty Claim": "/company/warranty-claim",
        "Meet Our Team": "/company/team",
        "Contact Us": "/company/contact",
        FAQs: "/company/faqs",
        "About Us": "/company/about-us",
        "Phone Screen": "/system/phone-screen",
        "Part & IC Chip": "/system/part-chip",
        "Access Zone": "/system/access-zone",
        "Counter Order": "/system/counter-order",
        "Official DOC": "/system/official-doc",
        "Latest News": "/live/latest-news",
        Live: "/live",
    };

    const menuItems = [
        "Home",
        ...(user ? ["Dashboard"] : []),
        "Franchise",
        "Company",
        ...(!user ? ["Jobs"] : []),
        "Booking Repair",
        "Offers Today",
    ];

    const dropdownItems = {
        Company: [
            "Terms & Conditions",
            "Privacy Policy",
            "Warranty Policy",
            "Warranty Claim",
            "Meet Our Team",
            "Contact Us",
            "FAQs",
            "About Us",
        ],
        Live: ["Live", "Latest News"],
        "Training Center": ["Academy", "Courses"],
        System: ["Phone Screen", "Part & IC Chip", "Acess Zone", "Counter Order", "Official DOS"],
        "Booking Repair": ["SmartPhone", "Feature Phone", "Tablet", "Smart Watch"]
    };

    const nestedDropdownItems: Record<string, string[]> = {
        "SmartPhone": smartphoneRepairs.map(r => r.name),
        "Feature Phone": featurePhoneRepairs.map(r => r.name),
        "Tablet": tabletRepairs.map(r => r.name),
        "Smart Watch": smartWatchRepairs.map(r => r.name),
    };

    useEffect(() => {
        const path = location.pathname;
        const matchedMainItem = Object.keys(menuRoutes)
            .sort((a, b) => menuRoutes[b].length - menuRoutes[a].length)
            .find((key) => path.startsWith(menuRoutes[key]));

        if (matchedMainItem) {
            setActiveNav(matchedMainItem);
            return;
        }
        setActiveNav("Home");
    }, [location.pathname]);

    // --- Body Scroll Lock ---
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isMobileMenuOpen]);

    // --- Scroll listener for header shadow ---
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setHasScrolled(true);
            } else {
                setHasScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // --- Handlers ---
    const handleToggle = () => {
        const isDesktop = window.innerWidth >= 1440;
        if (isDesktop) toggleSidebar();
        else toggleMobileSidebar();
    };

    const handleMenuClick = (item: string) => {
        if (item === "Dashboard") {
            setActiveNav(item);
            navigate("/applicant/dashboard");
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        if (dropdownItems[item as keyof typeof dropdownItems]) {
            setHoveredItem(item === hoveredItem ? null : item);
            return;
        }

        const route = menuRoutes[item];
        if (route) {
            setActiveNav(item);
            navigate(route);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleSubMenuClick = (subItem: string) => {
        setActiveNav(subItem);
        const route = dropdownRoutes[subItem];
        if (route) {
            navigate(route);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setHoveredItem(null);
        }
    };

    const handleMobileSearch = (e: React.FormEvent) => {
        e.preventDefault();
        if (mobileSearchQuery.trim()) {
            // Handle search logic here
            console.log("Searching for:", mobileSearchQuery);
            setMobileMenuOpen(false);
            setMobileSearchQuery("");
        }
    };

    return (
        <>
            {/* Header with Brand Background Logic */}
            <div className="sticky z-50 w-full transition-all duration-300 top-0">
                <header className={`w-full bg-white/90 dark:bg-gray-900/90 backdrop-blur-md transition-all duration-300 ${hasScrolled ? 'shadow-lg border-b border-gray-200/50 dark:border-gray-700/50' : ''}`}>
                    <div className="flex items-center justify-between h-14 sm:h-16 max-w-[1400px] mx-auto px-4 sm:px-6 w-full">

                        {/* --- MOBILE HEADER (Updated Layout) --- */}
                        <div className="xl:hidden flex items-center justify-between w-full h-14 bg-white dark:bg-gray-900 gap-2">
                            {/* Left: Hamburger + Logo + Menu Text */}
                            <div className="flex items-center gap-3 shrink-0">
                                <button
                                    onClick={() => setMobileMenuOpen(true)}
                                    className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                                >
                                    <Menu className="w-5 h-5 text-gray-700 dark:text-gray-200" />
                                </button>
                                <div
                                    className="flex items-center gap-2 cursor-pointer"
                                    onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                                >
                                    <img src={logo} alt="PhoneLab" className="h-6 w-auto object-contain" />
                                    <span className="text-gray-800 dark:text-gray-100 font-bold text-sm tracking-tight hidden xs:block uppercase">PhoneLab</span>
                                </div>
                            </div>

                            {/* Mobile Search Input */}
                            <div className="flex-1 max-w-[180px]">
                                <form onSubmit={handleMobileSearch} className="relative">
                                    <input
                                        type="text"
                                        value={mobileSearchQuery}
                                        onChange={(e) => setMobileSearchQuery(e.target.value)}
                                        placeholder="Search"
                                        className="w-full h-8 rounded-xl bg-gray-50 dark:bg-gray-800 px-3 pr-8 text-sm text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-700 outline-none placeholder-gray-400"
                                    />
                                    <Search className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                                </form>
                            </div>

                            {/* Mobile Profile Icon */}
                            <div className="flex items-center shrink-0 relative">
                                <button
                                    onClick={() => setIsMobileProfileMenuOpen(!isMobileProfileMenuOpen)}
                                    className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-95"
                                >
                                    {user ? (
                                        <div className="w-7 h-7 rounded-full border-2 border-brand-500 overflow-hidden shadow-sm">
                                            <img src={user?.profileImage || avatar} alt="Profile" className="w-full h-full object-cover" />
                                        </div>
                                    ) : (
                                        <div className="w-7 h-7 rounded-full bg-gray-50 dark:bg-gray-800 flex items-center justify-center border border-gray-200 dark:border-gray-700">
                                            <User className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                                        </div>
                                    )}
                                </button>

                                {/* Mobile Profile Dropdown */}
                                {isMobileProfileMenuOpen && (
                                    <>
                                        <div
                                            className="fixed inset-0 z-40"
                                            onClick={() => setIsMobileProfileMenuOpen(false)}
                                        />
                                        <div className="absolute right-0 top-full mt-2 w-48 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl ring-1 ring-black/5 dark:ring-white/10 border border-gray-100 dark:border-gray-800 py-1 z-50 animate-sideDropdownFadeIn">
                                            {!user ? (
                                                <>
                                                    <button
                                                        onClick={() => { setLoginOpen(true); setIsMobileProfileMenuOpen(false); }}
                                                        className="flex items-center gap-3 w-full px-4 py-3 text-sm font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                                                    >
                                                        <LogInIcon className="w-5 h-5 text-black" />
                                                        <span>Login</span>
                                                    </button>
                                                    <div className="h-[2px] bg-gray-200 dark:bg-gray-700 my-1.5" />

                                                    <button
                                                        onClick={() => { setRegisterOpen(true); setIsMobileProfileMenuOpen(false); }}
                                                        className="flex items-center gap-3 w-full px-4 py-3 text-sm font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                                                    >
                                                        <Users className="w-5 h-5 text-black" />
                                                        <span>Register</span>
                                                    </button>
                                                </>
                                            ) : (
                                                <>
                                                    <button
                                                        onClick={() => { navigate('/applicant/profile'); setIsMobileProfileMenuOpen(false); }}
                                                        className="flex items-center gap-3 w-full px-4 py-3 text-sm font-semibold text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                                                    >
                                                        <User className="w-5 h-5 text-black" />
                                                        <span>Profile</span>
                                                    </button>
                                                    <div className="h-[1.5px] bg-gray-200 dark:bg-gray-700 my-1.5" />

                                                    <button
                                                        onClick={() => { logout(); navigate('/'); setIsMobileProfileMenuOpen(false); }}
                                                        className="flex items-center gap-3 w-full px-4 py-3 text-sm font-semibold text-red-600 hover:bg-red-50 dark:hover:bg-red-950/30 transition-colors"
                                                    >
                                                        <LogOut className="w-5 h-5 text-red-500" />
                                                        <span>Logout</span>
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* --- DESKTOP HEADER (Hidden on Mobile) --- */}
                        <div className="hidden xl:flex items-center justify-between w-full h-full">
                            {/* --- LEFT SECTION: Logo --- */}
                            <div className="flex items-center gap-4">
                                <img
                                    src={footerLogo}
                                    alt="logo"
                                    className="h-7 w-auto hidden dark:block object-contain cursor-pointer transition-opacity"
                                    onClick={() => navigate("/")}
                                />
                                <img
                                    src={logo}
                                    alt="logo"
                                    className="h-7 w-auto block dark:hidden object-contain cursor-pointer transition-opacity"
                                    onClick={() => navigate("/")}
                                />
                            </div>

                            {/* --- MIDDLE SECTION: Desktop Navigation (Centered) --- */}
                            <nav className="hidden xl:flex flex-1 items-center justify-center px-6">
                                <ul className="flex items-center gap-0.5">
                                    {menuItems.map((item) => {
                                        const hasDropdown = !!dropdownItems[item as keyof typeof dropdownItems];
                                        const isActive = activeNav === item && !hasDropdown;
                                        const isHovered = hoveredItem === item;

                                        return (
                                            <li
                                                key={item}
                                                className="relative"
                                                onMouseEnter={() => setHoveredItem(item)}
                                                onMouseLeave={() => setHoveredItem(null)}
                                            >
                                                <button
                                                    onClick={() => {
                                                        if (!hasDropdown) {
                                                            handleMenuClick(item);
                                                        }
                                                    }}
                                                    className={`group flex items-center gap-1 px-3 py-1.5 text-[14px] font-semibold transition-all duration-300 rounded-full ${isActive
                                                        ? "brand-bg text-white shadow-md shadow-brand-500/20"
                                                        : "text-black hover:text-brand-600 dark:text-gray-100 dark:hover:text-brand-400 hover:bg-brand-50/50 dark:hover:bg-brand-500/10"
                                                        }`}
                                                >
                                                    <span>{item}</span>
                                                    {hasDropdown && (
                                                        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-300 ${isHovered ? "rotate-180" : ""}`} />
                                                    )}
                                                </button>

                                                {hasDropdown && isHovered && (
                                                    <div
                                                        className="absolute top-full left-1 -translate-x-1/2 pt-2 w-64 z-[60] animate-sideDropdownFadeIn"
                                                        onMouseEnter={() => setHoveredItem(item)}
                                                        onMouseLeave={() => setHoveredItem(null)}
                                                    >
                                                        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl ring-1 ring-black/5 dark:ring-white/10 border border-gray-100 dark:border-gray-800 backdrop-blur-xl">
                                                            <div className="py-2">
                                                                {dropdownItems[item as keyof typeof dropdownItems]?.map((subItem) => {
                                                                    const hasNested = !!nestedDropdownItems[subItem];

                                                                    return (
                                                                        <div
                                                                            key={subItem}
                                                                            className="relative group/sub"
                                                                            onMouseEnter={() => { clearSubMenuTimer(); setHoveredSubItem(subItem); }}
                                                                            onMouseLeave={startSubMenuTimer}
                                                                        >
                                                                            <button
                                                                                onClick={() => {
                                                                                    if (!hasNested) {
                                                                                        handleSubMenuClick(subItem);
                                                                                        setHoveredItem(null);
                                                                                    }
                                                                                }}
                                                                                className={`flex items-center justify-between w-full px-5 py-2.5 text-sm font-medium transition-all duration-200 ${activeNav === subItem
                                                                                    ? "brand-bg text-white"
                                                                                    : "text-gray-600 dark:text-gray-300 hover:bg-brand-50 dark:hover:bg-brand-500/10 hover:text-brand-600 dark:hover:text-brand-400"
                                                                                    }`}
                                                                            >
                                                                                <div className="flex items-center">
                                                                                    {getIcon(subItem)}
                                                                                    <span>{subItem}</span>
                                                                                </div>
                                                                                {hasNested && <ChevronRight className="w-4 h-4 opacity-50 group-hover/sub:translate-x-1 transition-transform" />}
                                                                            </button>

                                                                            {hasNested && hoveredSubItem === subItem && (
                                                                                <div
                                                                                    className="absolute top-0 left-[calc(100%-4px)] w-64 z-[70] animate-sideDropdownFadeIn"
                                                                                    onMouseEnter={() => { clearSubMenuTimer(); setHoveredSubItem(subItem); }}
                                                                                    onMouseLeave={startSubMenuTimer}
                                                                                >
                                                                                    <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl ring-1 ring-black/5 dark:ring-white/10 overflow-hidden border border-gray-100 dark:border-gray-800 backdrop-blur-xl">
                                                                                        <div className="py-2">
                                                                                            {nestedDropdownItems[subItem].map((nestedItem, idx) => (
                                                                                                <button
                                                                                                    key={`${nestedItem}-${idx}`}
                                                                                                    onClick={() => {
                                                                                                        navigate(`/booking-repair/${encodeURIComponent(nestedItem)}`);
                                                                                                        window.scrollTo({ top: 0, behavior: "smooth" });
                                                                                                        setHoveredItem(null);
                                                                                                    }}
                                                                                                    className="flex items-center w-full px-5 py-2 text-[13px] text-gray-500 dark:text-gray-400 hover:bg-brand-50 dark:hover:bg-brand-500/10 hover:text-brand-600 dark:hover:text-brand-400 transition-colors"
                                                                                                >
                                                                                                    {getIcon(nestedItem)}
                                                                                                    <span className="truncate">{nestedItem}</span>
                                                                                                </button>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </nav>

                            {/* --- RIGHT SECTION: Desktop Search & Auth --- */}
                            <div className="flex items-center gap-2">
                                <div className="relative">
                                    <button
                                        onClick={() => setSearchOpen(!isSearchOpen)}
                                        className={`p-1.5 transition-colors rounded-full ${isSearchOpen
                                            ? 'bg-gray-100 text-brand-500 dark:bg-gray-800 dark:text-brand-400'
                                            : 'text-gray-600 hover:text-black dark:text-gray-300 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800'
                                            }`}
                                        aria-label="Search"
                                    >
                                        {isSearchOpen ? <X className="w-4 h-4" /> : <Search className="w-4 h-4" />}
                                    </button>

                                    {isSearchOpen && (
                                        <div className="absolute right-0 mt-2 w-72 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl ring-1 ring-black/5 dark:ring-white/10 p-3 z-[100] animate-sideDropdownFadeIn">
                                            <div className="relative">
                                                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                                                <input
                                                    type="text"
                                                    placeholder="Search repairs..."
                                                    className="w-full pl-9 pr-4 py-2 bg-gray-50 dark:bg-gray-800 border-none rounded-xl text-sm focus:ring-2 focus:ring-brand-500/20 outline-none"
                                                    autoFocus
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <a
                                    href="https://wa.me/YOUR_NUMBER"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="p-1.5 text-gray-600 hover:text-brand-600 dark:text-gray-300 dark:hover:text-brand-400 transition-colors"
                                    aria-label="WhatsApp"
                                >
                                    <WhatshappIcon className="w-5 h-5" />
                                </a>

                                <div className="h-5 w-px bg-gray-200 dark:bg-gray-700 mx-1" />

                                {!user ? (
                                    <div className="relative">
                                        <button
                                            onClick={() => setIsAuthDropdownOpen(!isAuthDropdownOpen)}
                                            className="flex items-center gap-2 px-4 py-1.5 text-sm font-semibold rounded-md border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                                        >
                                            <svg className="w-4 h-4" fill="#4b5563" viewBox="0 0 36 36" version="1.1" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>login-line</title> <path d="M28,4H12a2,2,0,0,0-2,2H28V30H12V20.2H10V30a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Z" class="clr-i-outline clr-i-outline-path-1"></path><path d="M15.12,18.46a1,1,0,1,0,1.41,1.41l5.79-5.79L16.54,8.29a1,1,0,0,0-1.41,1.41L18.5,13H4a1,1,0,0,0-1,1,1,1,0,0,0,1,1H18.5Z" class="clr-i-outline clr-i-outline-path-2"></path> <rect x="0" y="0" width="36" height="36" fill-opacity="0"></rect> </g></svg>
                                            <span>Login</span>
                                            <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-300 ${isAuthDropdownOpen ? 'rotate-180' : ''}`} />
                                        </button>

                                        {isAuthDropdownOpen && (
                                            <>
                                                <div
                                                    className="fixed inset-0 z-40"
                                                    onClick={() => setIsAuthDropdownOpen(false)}
                                                />
                                                <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-900 rounded-2xl shadow-2xl ring-1 ring-black/5 dark:ring-white/10 border border-gray-100 dark:border-gray-800 backdrop-blur-xl z-50 animate-sideDropdownFadeIn">
                                                    <div className="py-2">
                                                        <button
                                                            onClick={() => {
                                                                setLoginOpen(true);
                                                                setIsAuthDropdownOpen(false);
                                                            }}
                                                            className="flex items-center gap-3 w-full px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-colors"
                                                        >
                                                            <LogInIcon className="w-4 h-4" />
                                                            <span>Login</span>
                                                        </button>
                                                        <div className="h-px bg-gray-100 dark:bg-gray-800 my-1" />
                                                        <button
                                                            onClick={() => {
                                                                setRegisterOpen(true);
                                                                setIsAuthDropdownOpen(false);
                                                            }}
                                                            className="flex items-center gap-3 w-full px-5 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-colors"
                                                        >
                                                            <Users className="w-4 h-4" />
                                                            <span>Register</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ) : (
                                    <div className="relative">
                                        <button
                                            onClick={() => setIsUserMenuOpen((prev) => !prev)}
                                            className="flex items-center gap-2 p-0.5 pl-2 pr-2 transition-all"
                                        >
                                            <div className="w-7 h-7 rounded-full brand-bg text-white flex items-center justify-center text-xs font-bold overflow-hidden">
                                                <img
                                                    src={user?.profileImage || avatar}
                                                    alt="logo"
                                                    className=" w-full h-full object-cover cursor-pointer transition-opacity"
                                                    onError={(e) => {
                                                        e.currentTarget.src = avatar;
                                                    }}
                                                />
                                            </div>
                                            <div className="flex flex-col items-start">
                                                <span className="text-xs font-medium text-gray-700 dark:text-gray-100 max-w-[80px] truncate hidden sm:block">
                                                    {user?.fullName}
                                                </span>
                                                <span className="text-[10px] font-medium text-gray-400 truncate hidden sm:block">Applicant</span>
                                            </div>
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </button>

                                        {isUserMenuOpen && (
                                            <>
                                                <div
                                                    className="fixed inset-0 z-40"
                                                    onClick={() => setIsUserMenuOpen(false)}
                                                />
                                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 z-50 py-1">
                                                    <MenuItem
                                                        label="Dashboard"
                                                        onClick={() => { navigate("/applicant/dashboard"); setIsUserMenuOpen(false) }}
                                                    />
                                                    <MenuItem
                                                        label="Profile"
                                                        onClick={() => { navigate("/applicant/profile"); setIsUserMenuOpen(false) }}
                                                    />
                                                    <div className="border-t border-gray-100 my-1" />
                                                    <MenuItem
                                                        label="Logout"
                                                        danger
                                                        onClick={() => { logout(); navigate("/"); setIsUserMenuOpen(false); }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}

                                <button
                                    onClick={() => { navigate("/booking-repair"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                                    className="text-xs font-semibold px-4 py-1.5 rounded-full text-white brand-bg hover:brightness-110 shadow-md transition-all ml-1"
                                >
                                    Booking Repair
                                </button>
                            </div>
                        </div>
                    </div>
                </header>

                {/* --- MOBILE SLIDE-IN MENU --- */}
                {isMobileMenuOpen && (
                    <div
                        className={`xl:hidden fixed inset-0 top-0 z-[60] bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${isMenuClosing ? 'opacity-0' : 'opacity-100'}`}
                        onClick={closeMobileMenu}
                    >
                        <div
                            className={`absolute left-0 top-0 w-[93%] max-w-[420px] h-full bg-white dark:bg-gray-900 shadow-2xl flex flex-col ${isMenuClosing ? 'animate-sideDropdownFadeOut' : 'animate-sideDropdownFadeIn'}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Mobile Sidebar Header */}
                            <div className="flex items-center justify-between p-3 px-6 border-b border-gray-50 dark:border-gray-800 shrink-0">
                                <img src={logo} alt="PhoneLab" className="h-6 w-auto object-contain" />
                                <button
                                    onClick={closeMobileMenu}
                                    className="p-2 -mr-2 rounded-xl text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-90"
                                    aria-label="Close menu"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            </div>

                            <div className="flex-1 overflow-y-auto flex flex-col">
                                {/* User Profile at the TOP of Search */}
                                {user && (
                                    <div className="px-6 py-3 flex items-center justify-between bg-white dark:bg-gray-900 border-b border-gray-50 dark:border-gray-800">
                                        <div className="flex items-center gap-3">
                                            <div className="w-9 h-9 rounded-full border-2 border-brand-500 overflow-hidden shadow-sm shrink-0">
                                                <img src={user?.profileImage || avatar} alt="Profile" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.src = avatar; }} />
                                            </div>
                                            <div>
                                                <p className="text-sm font-bold text-gray-800 dark:text-gray-100 leading-tight">{user?.fullName}</p>
                                                <p className="text-xs font-medium text-gray-400">Applicant</p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => { logout(); navigate('/'); closeMobileMenu(); }}
                                            className="p-2 rounded-xl text-red-500 hover:bg-red-50 dark:hover:bg-red-950/30 transition-all active:scale-95"
                                            title="Logout"
                                        >
                                            <LogOut className="w-4.5 h-4.5" />
                                        </button>
                                    </div>
                                )}

                                {/* Mobile Search */}
                                <div className="px-6 py-2 bg-white dark:bg-gray-900">
                                    <form onSubmit={handleMobileSearch} className="relative">
                                        <div className="group relative flex items-center transition-all duration-300 ease-in-out">
                                            <div className="absolute left-4 z-10">
                                                <Search className="w-4 h-4 text-gray-400 group-focus-within:text-brand-500 transition-colors" />
                                            </div>
                                            <input
                                                type="text"
                                                value={mobileSearchQuery}
                                                onChange={(e) => setMobileSearchQuery(e.target.value)}
                                                placeholder="Search repairs..."
                                                className="w-full pl-11 pr-12 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-sm text-gray-800 dark:text-gray-100 placeholder-gray-400 focus:ring-2 focus:ring-brand-500/20 focus:bg-white dark:focus:bg-gray-900 transition-all outline-none"
                                            />
                                            {mobileSearchQuery && (
                                                <button
                                                    type="button"
                                                    onClick={() => setMobileSearchQuery("")}
                                                    className="absolute right-3 p-1.5 rounded-lg bg-gray-200/50 dark:bg-gray-700/50 hover:bg-gray-200 dark:hover:bg-gray-600 transition-all active:scale-90"
                                                >
                                                    <X className="w-3 h-3 text-gray-500 dark:text-gray-300" />
                                                </button>
                                            )}
                                        </div>
                                    </form>

                                    {/* Action Cards for Logged-in Users */}
                                    {user && (
                                        <div className="space-y-2 mt-3">
                                            {/* Row 1 */}
                                            <div className="grid grid-cols-2 gap-2">
                                                {/* Applicant Status */}
                                                <button
                                                    onClick={() => { navigate('/applicant/applied'); closeMobileMenu(); }}
                                                    className="flex items-center gap-2 py-4 px-2 rounded-xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md hover:border-blue-200 dark:hover:border-blue-800 transition-all active:scale-95 group"
                                                >
                                                    <div className="w-7 h-7 rounded-lg bg-blue-50 dark:bg-blue-600/10 flex items-center justify-center group-hover:bg-blue-100 dark:group-hover:bg-blue-600/20 transition-colors">
                                                        <ClipboardCheck className="w-3.5 h-3.5 text-[#2563eb] dark:text-blue-600" />
                                                    </div>
                                                    <div className="flex-1 text-left">
                                                        <p className="text-[11px] font-medium text-gray-700 dark:text-gray-200">Applicant Status</p>
                                                    </div>
                                                </button>

                                                {/* My Orders */}
                                                <button
                                                    onClick={() => { navigate('/applicant/order'); closeMobileMenu(); }}
                                                    className="flex items-center gap-2 py-4 px-2 rounded-xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md hover:border-orange-200 dark:hover:border-orange-800 transition-all active:scale-95 group"
                                                >
                                                    <div className="w-7 h-7 rounded-lg bg-orange-50 dark:bg-orange-500/10 flex items-center justify-center group-hover:bg-orange-100 dark:group-hover:bg-orange-500/20 transition-colors">
                                                        <Package className="w-3.5 h-3.5 text-orange-600 dark:text-orange-400" />
                                                    </div>
                                                    <div className="flex-1 text-left">
                                                        <p className="text-[11px] font-medium text-gray-700 dark:text-gray-200">My Orders</p>
                                                    </div>
                                                </button>
                                            </div>

                                            {/* Row 2 */}
                                            <div className="grid grid-cols-2 gap-2">
                                                {/* Jobs */}
                                                <button
                                                    onClick={() => { navigate('/jobs'); closeMobileMenu(); }}
                                                    className="flex items-center gap-2 py-4 px-2 rounded-xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md hover:border-green-200 dark:hover:border-green-800 transition-all active:scale-95 group"
                                                >
                                                    <div className="w-7 h-7 rounded-lg bg-green-50 dark:bg-green-500/10 flex items-center justify-center group-hover:bg-green-100 dark:group-hover:bg-green-500/20 transition-colors">
                                                        <Briefcase className="w-3.5 h-3.5 text-green-600 dark:text-green-400" />
                                                    </div>
                                                    <div className="flex-1 text-left">
                                                        <p className="text-[11px] font-medium text-gray-700 dark:text-gray-200">Jobs</p>
                                                    </div>
                                                </button>

                                                {/* Profile Setting */}
                                                <button
                                                    onClick={() => { navigate('/applicant/profile'); closeMobileMenu(); }}
                                                    className="flex items-center gap-2 py-4 px-2 rounded-xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md hover:border-purple-200 dark:hover:border-purple-800 transition-all active:scale-95 group"
                                                >
                                                    <div className="w-7 h-7 rounded-lg bg-purple-50 dark:bg-purple-500/10 flex items-center justify-center group-hover:bg-purple-100 dark:group-hover:bg-purple-500/20 transition-colors">
                                                        <Settings className="w-3.5 h-3.5 text-purple-600 dark:text-purple-400" />
                                                    </div>
                                                    <div className="flex-1 text-left">
                                                        <p className="text-[11px] font-medium text-gray-700 dark:text-gray-200">Profile Setting</p>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>)}

                                    {/* Auth Buttons for Non-logged-in Users */}
                                    {!user && (
                                        <div className="grid grid-cols-2 gap-3 mt-5">
                                            <button
                                                onClick={() => { setLoginOpen(true); setMobileMenuOpen(false); }}
                                                className="py-2.5 text-sm font-bold rounded-full border border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-95 flex items-center justify-center gap-2"
                                            >
                                                <LogIn size={16} />
                                                Log in
                                            </button>
                                            <button
                                                onClick={() => { setRegisterOpen(true); closeMobileMenu(); }}
                                                className="py-2.5 text-sm font-bold rounded-full border border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all active:scale-95 flex items-center justify-center gap-2"
                                            >
                                                <UserPlus size={16} />
                                                Get Started
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Mobile Navigation Items */}
                                <nav className="py-2 border-t border-gray-50 dark:border-gray-800">
                                    {menuItems.map((item) => {
                                        const hasDropdown = !!dropdownItems[item as keyof typeof dropdownItems];
                                        const isExpanded = expandedMobileItem === item;

                                        return (
                                            <div key={item} className="border-b border-gray-50 dark:border-gray-800/50 last:border-0">
                                                <button
                                                    onClick={() => {
                                                        if (hasDropdown) {
                                                            setExpandedMobileItem(isExpanded ? null : item);
                                                            setExpandedMobileSubItem(null);
                                                        } else {
                                                            handleMenuClick(item);
                                                            closeMobileMenu();
                                                        }
                                                    }}
                                                    className={`flex items-center justify-between w-full px-5 py-3 text-[14px] font-medium transition-colors ${activeNav === item
                                                        ? 'brand-text font-semibold'
                                                        : 'text-black dark:text-gray-100'
                                                        }`}
                                                >
                                                    <div className="flex items-center gap-3">
                                                        <span className={`${activeNav === item ? 'brand-text' : 'text-black dark:text-gray-400'}`}>
                                                            {getMobileIcon(item)}
                                                        </span>
                                                        <span>{item}</span>
                                                    </div>
                                                    {hasDropdown && (
                                                        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
                                                    )}
                                                </button>

                                                {/* Mobile Dropdown */}
                                                {hasDropdown && isExpanded && (
                                                    <div className="bg-gray-50/80 dark:bg-gray-800/50 animate-dropdownFadeIn">
                                                        {dropdownItems[item as keyof typeof dropdownItems]?.map((subItem) => {
                                                            const hasNested = !!nestedDropdownItems[subItem];
                                                            const isSubExpanded = expandedMobileSubItem === subItem;

                                                            return (
                                                                <div key={subItem}>
                                                                    <button
                                                                        onClick={() => {
                                                                            if (hasNested) {
                                                                                setExpandedMobileSubItem(isSubExpanded ? null : subItem);
                                                                            } else {
                                                                                handleSubMenuClick(subItem);
                                                                                closeMobileMenu();
                                                                            }
                                                                        }}
                                                                        className={`flex items-center justify-between w-full pl-8 pr-5 py-2.5 text-sm transition-colors ${activeNav === subItem
                                                                            ? 'brand-text font-semibold'
                                                                            : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
                                                                            }`}
                                                                    >
                                                                        <div className="flex items-center">
                                                                            {getIcon(subItem)}
                                                                            <span>{subItem}</span>
                                                                        </div>
                                                                        {hasNested && (
                                                                            <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isSubExpanded ? 'rotate-180' : ''}`} />
                                                                        )}
                                                                    </button>

                                                                    {/* Mobile Nested Dropdown */}
                                                                    {hasNested && isSubExpanded && (
                                                                        <div className="bg-gray-100/80 dark:bg-gray-800/80 animate-dropdownFadeIn">
                                                                            {nestedDropdownItems[subItem].map((nestedItem, idx) => (
                                                                                <button
                                                                                    key={`${nestedItem}-${idx}`}
                                                                                    onClick={() => {
                                                                                        navigate(`/booking-repair/${encodeURIComponent(nestedItem)}`);
                                                                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                                                                        closeMobileMenu();
                                                                                    }}
                                                                                    className="flex items-center w-full pl-12 pr-5 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
                                                                                >
                                                                                    {getIcon(nestedItem)}
                                                                                    <span className="truncate">{nestedItem}</span>
                                                                                </button>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </nav>

                                {/* Booking Repair CTA */}
                                <div className="p-5">
                                    <button
                                        onClick={() => { navigate('/booking-repair'); window.scrollTo({ top: 0, behavior: 'smooth' }); closeMobileMenu(); }}
                                        className="w-full py-3 text-sm font-bold rounded-xl text-white brand-bg hover:brightness-110 shadow-lg shadow-brand-500/20 transition-all flex items-center justify-center gap-2"
                                    >
                                        <WrenchIcon className="w-4 h-4" />
                                        Book a Repair
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <RegisterModal
                isOpen={isRegisterOpen}
                onClose={() => setRegisterOpen(false)}
                onSwitchToLogin={() => {
                    setRegisterOpen(false);
                    setLoginOpen(true);
                }}
            />
            <LoginModal
                isOpen={isLoginOpen}
                onClose={() => setLoginOpen(false)}
                onForgotPassword={() => {
                    setLoginOpen(false);
                    setForgotPasswordOpen(true);
                }}
                onSwitchToRegister={() => {
                    setLoginOpen(false);
                    setRegisterOpen(true);
                }}
                onSuccess={() => {
                    fetchUser();
                    setLoginOpen(false);
                }}
            />
            <ForgotPasswordModal
                isOpen={isForgotPasswordOpen}
                onClose={() => setForgotPasswordOpen(false)}
                onSwitchToLogin={() => {
                    setForgotPasswordOpen(false);
                    setLoginOpen(true);
                }}
            />
        </>
    );
};

export default AppHeader;